import React from 'react';

import {ActionsRow} from '@pexip/components';

export const SettingsActionsRow: React.FC<
    Omit<React.ComponentProps<typeof ActionsRow>, 'hasDivider'>
> = props => <ActionsRow hasDivider={false} {...props} />;
